module.exports = __webpack_public_path__ + "static/img/policy-header_768.bd1280e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-header_768.png
// module id = 9kMk
// module chunks = 0